import React from 'react';
import storage from "../storage";
import i18n from "../i18n";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

class PortalOrdersWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    }

    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.props.attachListenerOnOpen(() => {
      this.setState({
        ...this.state,
        open: true,
      });
    });

    this.props.attachListenerOnClose(() => {
      this.setState({
        ...this.state,
        open: false,
      });
    });
  }

  close() {
    this.setState({
      ...this.state,
      open: false,
    });
  }
  render() {
    return (
      <div className={`basket ${this.state.open ? 'open' : ''}`}>
        <div
          className="backdrop"
          onClick={this.close}
        ></div>
        <div className="container">
            <div className="header">
              <FontAwesomeIcon
                  icon={faTimes}
                  className="btn-close"
                  onClick={this.close}
              />
            </div>
          <div className="w-100 overflow-auto">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default PortalOrdersWrapper;